import { WhatsAppOutlined } from '@ant-design/icons'
import { Flex } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { PhoneNumber } from '../phone-number'
import { QualityRatingBadge } from './quality-rating-badge'

export type PhoneNumberListProps = {
    phoneNumbers: PhoneNumber[]
}

// Phone numbers are the lines candidates message. Most accounts have one, so
// they read as part of the account's identity: one quiet line each.
export function PhoneNumberList({ phoneNumbers }: PhoneNumberListProps) {
    const { t } = useTranslation()

    if (phoneNumbers.length === 0) {
        return (
            <div className="rounded-xl bg-surface-muted px-4 py-3 text-[13px] text-ink-tertiary">
                {t('No phone numbers found')}
            </div>
        )
    }

    return (
        <div className="rounded-xl bg-surface-muted">
            {phoneNumbers.map((phoneNumber) => (
                <Flex
                    key={phoneNumber.id}
                    align="center"
                    justify="space-between"
                    gap="middle"
                    wrap="wrap"
                    className="border-b border-hairline px-4 py-2.5 last:border-b-0"
                >
                    <Flex
                        align="center"
                        gap={10}
                        className="min-w-0"
                    >
                        <WhatsAppOutlined className="text-base text-whatsapp" />
                        <span className="text-sm font-medium tabular-nums text-ink">{phoneNumber.number}</span>
                        <span className="truncate text-[13px] text-ink-tertiary">{phoneNumber.name}</span>
                    </Flex>

                    <Flex
                        align="center"
                        gap={8}
                        className="shrink-0 text-xs"
                    >
                        <span className="text-ink-tertiary">{t('Quality')}</span>
                        <QualityRatingBadge
                            rating={phoneNumber.qualityRating}
                            className="[&_.ant-badge-status-text]:text-xs"
                        />
                    </Flex>
                </Flex>
            ))}
        </div>
    )
}
